import React, { useContext, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar.jsx';
import Homepage from './pages/Homepage/Homepage.jsx';
import Sidebar from './components/Sidebar/Sidebar.jsx';
import Serverpage from './pages/Serverpage/Serverpage.jsx';
import Footer from './components/Footer/Footer.jsx';
import Rulepage from './pages/Rulepage/Rulepage.jsx';
import Kontaktpage from './pages/Kontaktpage/Kontaktpage.jsx';
import Calendarpage from './pages/Calendarpage/Calendarpage.jsx';
import Errorpage from './pages/Errorpage/Errorpage.jsx';
import BackToTop from './components/BackToTop/BackToTop.jsx';
import SideStatus from './components/SideStatus/SideStatus.jsx';
import Livepage from './pages/Livepage/Livepage.jsx';
import InfoModal from './components/InfoModal/InfoModal.jsx';
import EventModal from './components/EventModal/eventModal.jsx';
import { ModalContext } from './contexts/ModalContext.js';

function App() {
	const path = useLocation();

	const { isInfoModalOpen, isEventModalOpen } = useContext(ModalContext);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, [path])

  return (
    <>
			<Navbar />
			<Sidebar />
			<SideStatus />
			<main>
				<Routes>
					<Route path='/' element={<Homepage />} />
					<Route path='/server' element={<Serverpage />} />
					<Route path='/infos' element={<Rulepage />} />
					<Route path='/kontakt' element={<Kontaktpage />} />
					<Route path='/streamer' element={<Livepage />} />
					<Route path='/kalender' element={<Calendarpage />} />
					<Route path='*' element={<Errorpage />} />
				</Routes>
				{isInfoModalOpen && <InfoModal />}
				{isEventModalOpen && <EventModal />}
				<BackToTop />
			</main>
			<Footer />
    </>
  );
}

export default App;
